export const styles = (theme) => ({
  centerContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "450px",
  },
  contentLinks: {
    display: "flex",
    justifyContent: "end",
    gap: "16px",
  },
  contentHeader: {
    display: "flex",
    justifyContent: "space-between",
  },
  headerTitle: {
    fontSize: "24px",
    fontWeight: "600",
    margin: "0px",
  },
  filterAreaSearch: {
    marginTop: "20px",
    marginBottom: "20px",
  },
});